export default s => {
  // this will always match because empty string is ok
  const [_, ipart, fpart] = s.replace(/[^\d.]/g, '').match(/^(\d*)(\.?\d{0,2})/);
  return (ipart ? parseInt(ipart).toLocaleString() : '') + fpart;
};
